import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="color-picker"
export default class extends Controller {
  static targets = ['picker', 'input']

  updateInput() {
    this.inputTarget.value = this.pickerTarget.value
  }

  updatePicker() {
    this.pickerTarget.value = this.inputTarget.value
  }
}
